import React, { useState } from "react";
import Sidebar from "./AppointmentSidebar";

const AppointmentDoctorSidebar = ({ props }) => {
  const [isConsentGiven, setIsConsentGiven] = useState(false);

  return (
    <Sidebar>
      <div className="appointment-info-card">
        <div className="appointment-info-card__content">
          <div className="appointment-info-card__section">
            <div className="appointment-info-card__header appointment-info-card__header_indent-b_normal">
              Врач
            </div>
            <div className="appointment-info-card__doctor-info">
              <div className="appointment-info-card__doctor-photo">
                <img src={props.photoUrl} alt={props.doctorFullname} title={props.doctorFullname} />
              </div>
              <div className="appointment-info-card__doctor-name">
                {props.doctorLastname}
                <span>{props.doctorFullname}</span>
              </div>
            </div>
          </div>
          <div className="appointment-info-card__section">
            <div className="appointment-info-card__header appointment-info-card__header_indent-b_normal">
              Услуга
            </div>
            <div className="appointment-info-card__label">{props.service}</div>
          </div>
          <div className="appointment-info-card__section">
            <div className="appointment-info-card__header appointment-info-card__header_indent-b_normal">
              Клиника
            </div>
            <div className="appointment-info-card__label">
              {props.address}
            </div>
          </div>
          {
            // <div className="appointment-info-card__section">
            //   <div className="appointment-info-card__header appointment-info-card__header_indent-b_normal">
            //     Желаемая дата посещения
            //   </div>
            //   <div className="appointment-info-card__label appointment-info-card__label-day">{props.scheduledDay}</div>
            //   <div className="appointment-info-card__label appointment-info-card__label-time">{props.scheduledTime}</div>
            // </div>
          }
        </div>
        <div className="appointment-info-card__footer">
          <input type='submit' className="button button_large button_full-width"
            value={props.btn_title}
            disabled={!isConsentGiven}
          />
        </div>
      </div>
      <div className="appointment-form__note appointment-form__note_indent-t_large">
        Нажав «Записаться» вы соглашаетесь с <a href="https://irk.klinikaexpert.ru/uploads/document/file/107/%D0%9F%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0_%D0%B2_%D0%BE%D1%82%D0%BD%D0%BE%D1%88%D0%B5%D0%BD%D0%B8%D0%B8_%D0%BE%D0%B1%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BA%D0%B8_%D0%9F%D0%94.pdf" target="_blank">условиями</a> использования вебсайта «Эксперт»
      </div>
      <div className="appointment-form__note appointment-form__note_indent-t_large appointment-form__note_sidebar">
        <input type="checkbox" id="personal_data" name="personal_data"
          checked={isConsentGiven}
          onChange={(e) => setIsConsentGiven(e.target.checked)}/>
        <label htmlFor="personal_data"> Нажимая кнопку, вы даете <a href="https://irk.klinikaexpert.ru/personal-data-consent" target="_blank">согласие на обработку персональных данных</a></label>
      </div>
    </Sidebar>
  );
};

export default AppointmentDoctorSidebar;
